import * as req from "@/utils/request";
import SnowflakeId from "snowflake-id";
const snowflake = new SnowflakeId({
  mid: 42,
  offset: (2019 - 1970) * 31536000 * 1000,
});

export class Globel {
  constructor() {
    this.name = "globel";
    // 船舶列表
    this.shipList = [];
    this.shipOptions = [];
    // 船队列表
    this.shipQueueList = [];
    this.shipQueueOptions = [];
    // 主页查询内容
    this.mainSearch = {};
    this.recordJson = {};
    /* 检查列表基础数据 */
    this.setCheckItemList = [];
    /* 缺陷基础数据 */
    this.setDefectList = [];
    /* 岗位列表 */
    this.postList = [];
    /* 当前文件下载状态 */
    this.events = false;
    // 获取检查报告详情的历史数据列表
    this.historyListData = [];
    // 获取检查报告详情的历史数据的船名，航线等信息
    this.historyListDataInfo = {};
    // 账号所属船舶ip列表
    this.shipIdList = [];
    this.getShipLists();
    this.getShipQueueList();
    // 审核编辑
    this.isEdit = false;
    // 屏幕放大缩小比例
    this.systemRatio = 0;
    // zoom比例
    this.size = 0;
    this.getSystemRatio();
    // 用户管理切换下标
    this.userIndex = 0;
    this.allData = {};
    // this.checkItemList = []
    this.defectList = [];
    // viewDetails界面title显示标识
    this.viewDialogTitle = true;
    // 获取缺陷基础数据,相关数据
    this.sendSyncInteface();
    // 检查列表
    this.recodeData = {
      id: null,
      checkId: null,
      checkItemId: 0,
      isMandatory: false,
      optionType: 0,
      remark: "",
      checkContent: "",
      images: [],
      score: 0,
      isDelete: false,
      createBy: "",
      deleteBy: "",
      createTime: "",
      reviewed: false,
      chapterName: "",
      postId: null,
    };
    // 缺陷列表
    this.defectData = {
      id: null,
      checkId: null,
      checkItemId: null,
      defectId: 0,
      type: 0,
      isChoose: false,
      score: 0,
      isDelete: false,
      createBy: "",
      createTime: "",
      deleteBy: "",
      checkRecordId: "",
    };
    // 分值列表
    this.scoreData = {
      id: null,
      checkId: null,
      chapterName: null,
      errBaseCount: 0,
      errEasyCount: 0,
      errMediumCount: 0,
      errHighCount: 0,
      otherBaseCount: 0,
      otherEasyCount: 0,
      otherMediumCount: 0,
      otherHighCount: 0,
    };
    // 章节列表
    this.chapterList = [
      {
        name: "第二章",
        label: "证书与文件",
      },
      {
        name: "第三章",
        label: "船员管理",
      },
      {
        name: "第四章",
        label: "航行安全",
      },
      {
        name: "第五章",
        label: "安全管理",
      },
      {
        name: "第六章",
        label: "防止污染",
      },
      {
        name: "第七章",
        label: "结构状况与维护保养",
      },
      {
        name: "第八章",
        label: "货物与压载系统",
      },
      {
        name: "第九章",
        label: "系泊与锚泊",
      },
      {
        name: "第十章",
        label: "通信导航",
      },
      {
        name: "第十一章",
        label: "机舱与舵机系统",
      },
      {
        name: "第十二章",
        label: "总体外观与状况",
      },
      {
        name: "第十三章",
        label: "冰区操作",
      },
    ];
    // 模版id
    this.templateId = null;
    // 专项检查查看详情标识
    this.isSpecial = false;
    // 专项检查项数据
    this.specialCheckData = [];
    // 检查项管理详情数据
    this.checkItemDetail = {};
    // 检查地点
    this.inspectionLocationList = [
      "大副办公室",
      "生活区",
      "厨房",
      "医院",
      "冰库",
      "驾驶台",
      "甲板",
      "其他",
      "船长办公室",
      "救生艇",
      "救生设备",
      "救助艇",
      "救生筏",
      "演习",
      "消防设备",
      "船舶保安员办公室",
      "轮机长办公室",
      "机舱",
      "货舱",
      "系泊设备",
      "锚设备",
      "锅炉间",
      "应急发电机",
    ];
    // 检查周期
    this.cycleOptions = [
      {
        value: "all",
        label: "全部",
      },
      {
        value: "WEEKLY",
        label: "每周",
      },
      {
        value: "MONTHLY",
        label: "每月",
      },
      {
        value: "EVERY_THREE_MONTHS",
        label: "每三个月",
      },
      {
        value: "QUAETERLY",
        label: "每季度",
      },
      {
        value: "SEMI_ANNUALLY",
        label: "每半年",
      },
      {
        value: "TWO_POINT_FIVE_YEARS",
        label: "每2.5年",
      },
    ];
    // 职位列表
    this.postListSelect = [
      {
        code: "CAPTAIN",
        name: "船长",
      },
      {
        code: "CHIEF_ENGINEER",
        name: "轮机长",
      },
      {
        code: "CHIEF_OFFICER",
        name: "大副",
      },
      {
        code: "SECOND_OFFICER",
        name: "二副",
      },
      {
        code: "THIRD_OFFICER",
        name: "三副",
      },
      {
        code: "CHIEF_ENGINEROOM",
        name: "大管轮",
      },
      {
        code: "SECOND_ENGINEROOM",
        name: "二管轮",
      },
      {
        code: "THREE_ENGINEROOM",
        name: "三管轮",
      },
      {
        code: "POLITICAL_COMMISSAR",
        name: "政委",
      },
      {
        code: "ELECTRICIAN",
        name: "电机员",
      },
      {
        code: "SYSTEM_SUPERVISOR",
        name: "体系主管",
      },
      {
        code: "TECHNICAL_SUPERVISOR",
        name: "技术主管",
      },
      {
        code: "INTERNAL_AUDITOR",
        name: "内审员",
      },
      {
        code: "SEAFARER",
        name: "海务",
      },
      {
        code: "ENGINEERING",
        name: "机务",
      },
      {
        code: "GROUP_SECURITY_INSPECTOR",
        name: "集团安检员",
      },
      {
        code: "NAVIGATION_GUIDANCE",
        name: "通导",
      },
      {
        code: "SECOND_OFFICER_A",
        name: "二副A",
      },
      {
        code: "SECOND_OFFICER_B",
        name: "二副B",
      },
      {
        code: "ELECTRICIAN_A",
        name: "电工",
      },
      {
        code: "CHIEF_PASSENGER_AGENT",
        name: "客运主任",
      },
      {
        code: "SHIP_SECURITY_OFFICE",
        name: "船舶保安员",
      },
      {
        code: "OPERATOR",
        name: "驾驶员",
      },
      {
        code: "PERSON_IN_CHARGE",
        name: "责任人",
      },
      {
        code: "DEPARTMENT_HEAD",
        name: "部门长",
      },
      {
        code: "MARINE_ENGINEER",
        name: "轮机员",
      },
    ];
    // 获取所有检查项列表
    this.allCheckItemList = [];
    // 获取缺陷的字典型数据
    this.dictData = [];
    // 下发船队groupId
    this.groupId = "";
    this.shoreUserlist = [];
    this.getShoreUserlistByAuthorization();
    // 专项检查被指派发布的船舶对象
    this.publishForSpecial = [];
    this.loadingTable = false;
    // 二级整改列表
    this.rectificationList = [];
    // 二级整改添加整改的船舶id
    this.rectificationShipid = 1;
    this.rectificationGroupid = null;
    // risq检查项
    this.risqCheckItemList = [];
    this.risqCheck = "";
  }
  // 根据token获取船队的岸基用户,此功能登录后才能获取
  getShoreUserlistByAuthorization() {
    let Authorization = localStorage.getItem("Authorization");
    if (!Authorization) {
      return;
    }
    this.getShoreUserlist();
  }
  // 根据船队名获取岸基用户
  getShoreUserlist() {
    this.send("/admin/user/shore/list", null, this, this.setShoreUserlist, "Get");
  }

  setShoreUserlist(res) {
    if (!res) return;
    if (res.code !== 200) {
      return;
    }
    this.shoreUserlist = res.data;
  }

  getDictData() {
    this.send("/sys/dict/dictData/DEFECT_CATEGORY", null, this, this.setDictData, "Get");
  }

  setDictData(res) {
    if (!res) return;
    if (res.code !== 200) {
      return;
    }
    this.dictData = res.data;
  }
  // 获取所有数据
  sendSyncInteface() {
    this.getAllData();
    this.getAllCheckItemList();
    this.getDictData();
  }

  getAllCheckItemList() {
    let obj = {
      pageNum: 0,
      pageSize: -1,
      chapter: "",
      code: "",
      location: "",
      mandatory: null,
      period: [],
      post: [],
      title: "",
    };
    this.send("/check-item/", obj, this, this.rescheckItemList);
  }

  rescheckItemList(res) {
    if (!res) return;
    if (res.code !== 200) {
      this.$message.warning(res.message);
      return;
    }
    this.allCheckItemList = res.data.records;
  }

  getAllData() {
    let currTime = null;
    this.send("/sync/data/all/v2", currTime, this, this.resGetAllData, "Get");
  }

  resGetAllData(res) {
    if (!res) {
      return;
    }
    if (res.code !== 200) {
      return;
    }
    let allData = res.data;

    this.allData = allData;
    // 缺陷列表
    this.setDefectList = allData.checkItemDefectList;

    // 岗位列表
    this.postList = allData.postList;

    // risq检查项
    this.risqCheckItemList = allData.risqCheckItemList;

    let defetList = allData.checkItemDefectList;

    for (let j in defetList) {
      let data = defetList[j];
      let id = data.id;
      this.defectList[id] = data;
    }
  }

  initSize() {
    document.styleSheets[document.styleSheets.length - 1].insertRule(`canvas {zoom:${1 / this.size}}`);
    document.styleSheets[document.styleSheets.length - 1].insertRule(`canvas {transform: scale(${this.size})}`);
    document.styleSheets[document.styleSheets.length - 1].insertRule("canvas {transform-origin: 0 0}");
  }
  // 获取屏幕缩放比例
  getSystemRatio() {
    // 解决屏幕分辨率问题
    let systemRatio = window.devicePixelRatio;
    this.systemRatio = systemRatio;
    let size = 1 / systemRatio;
    this.size = size;
    // document.body.style.zoom = size
  }

  getShipLists() {
    let shipList = localStorage.getItem("userInfo");
    if (!shipList) {
      return;
    }
    let shipObj = JSON.parse(shipList);
    this.shipIdList = shipObj.shipId;
  }
  send(type, obj, vm, resFn, getType = "Post") {
    let sendData = {};
    sendData.vm = vm;
    sendData.fn = resFn;
    sendData.data = obj;
    req[getType](type, sendData);
  }
  // 获取船舶列表
  getShipList() {
    let obj = {};
    this.send("/sys/ship/get", obj, this, this.resShipList, "Get");
  }
  resShipList(res) {
    if (!res) return;
    if (res.code !== 200) {
      return;
    }

    this.shipList = res.data;

    this.shipOptions = [];
    res.data.forEach((item) => {
      let obj = {
        label: item.name,
        value: item.id,
      };
      this.shipOptions.push(obj);
    });
  }
  // 获取船舶级联列表
  getShipQueueList() {
    let token = window.localStorage.getItem("Authorization");

    if (!token) {
      return;
    }
    let obj = {};
    this.send("/admin/ship/cascader", obj, this, this.resShipQueueList, "Get");
  }
  resShipQueueList(res) {
    if (!res) return;
    if (res.code !== 200) {
      return;
    }
    let list = res.data;
    this.shipQueueOptions = [];

    // 过滤掉不属于权限的船舶
    let idsSet = new Set(this.shipIdList.map((item) => item));
    let commonElements = [];
    for (let i in list) {
      let item = list[i];
      let childList = item.children.filter((child) => idsSet.has(child.id));
      if (childList.length === 0) {
        continue;
      }
      let obj = {
        firm: childList[0].firm,
        children: childList,
      };
      commonElements.push(obj);
    }
    this.shipQueueList = commonElements;
    commonElements.forEach((item) => {
      let obj = {
        label: item.firm,
        value: item.firm,
        children: [],
      };
      item.children.forEach((item2) => {
        obj.children.push({
          label: item2.name,
          value: item2.id,
        });
      });
      this.shipQueueOptions.push(obj);
    });
    // 添加其他船
    // let other = {
    //   label: '其他',
    //   value: '其他',
    //   children: [{
    //     label: '其他',
    //     value: 0
    //   }
    //   ]
    // }
    // this.shipQueueOptions.push(other)
  }
  // 表格头部样式
  headerRowStyle() {
    return {
      color: "#646464",
      background: "#EAF3FC",
      fontSize: "18px",
      height: "45px",
      padding: "0",
    };
  }
  // 表格内容样式
  rowStyle() {
    return {
      color: "#646464",
      fontSize: "18px",
    };
  }

  // 斑马纹样式
  tableRowClassName({ row, rowIndex }) {
    if (!row) {
      return "";
    }
    if (rowIndex % 2 === 1) {
      return "custom_stripe";
    } else {
      return "";
    }
  }

  rowStyleHeight(height) {
    let numHeight = height;
    if (numHeight === 0) return;
    let fontSize = 18;
    let oldCellHeight = fontSize + 31 + 1;
    let cellHeight = numHeight - oldCellHeight;
    let newCellHeight = cellHeight / 10;

    return {
      height: newCellHeight + "px",
    };
  }

  getTableHeight(height) {
    let numHeight = height;
    if (numHeight === 0) return;
    let fontSize = 18;
    let oldCellHeight = fontSize + 31;
    let cellHeight = numHeight - oldCellHeight;
    let newCellHeight = cellHeight / 10;
    // 总高度
    let res = newCellHeight * 10 + oldCellHeight;
    let newHeight = res;
    if (numHeight >= res) {
      newHeight = numHeight;
    }
    return newHeight;
  }

  // 数组分页
  pageData(list, page, pageSize) {
    return list.slice((page - 1) * pageSize, page * pageSize);
  }
  /* 根据id获取检查项数据 */
  getCheckItemById(id) {
    let item = this.setCheckItemList.find((item) => {
      return item.id === id;
    });
    return item;
  }

  /* 根据id获取risq检查项数据 */
  getrisqCheckItemById(id) {
    let item = this.risqCheckItemList.find((item) => {
      return item.id === id;
    });
    return item;
  }
  /* 根据id获取缺陷数据 */
  getDefectById(id) {
    let item = this.setDefectList.find((item) => {
      return item.id === id;
    });
    return item;
  }

  // 重置ship数据
  resetShip() {
    let arr = [];
    for (let i in this.shipQueueOptions) {
      let item1 = this.shipQueueOptions[i];
      for (let i in item1.children) {
        let item2 = item1.children[i];
        let arr2 = [];
        arr2.push(item1.label);
        arr2.push(item2.value);
        arr.push(arr2);
      }
    }
    return arr;
  }

  getStyle(obj, attr) {
    // 兼容IE浏览器
    let result = obj.currentStyle
      ? obj.currentStyle[attr].replace("px", "")
      : document.defaultView.getComputedStyle(obj, null)[attr].replace("px", "");
    return Number(result);
  }
  // 表格回到顶部
  backTop(vm) {
    vm.bodyWrapper.scrollTop = 0;
  }

  // 生成uuid
  UUID() {
    const id = snowflake.generate();
    return id;
  }

  getDefectListByCheckId(checkId) {
    let list = [];
    for (let i in this.defectList) {
      let defaultData = this.defectList[i];
      if (defaultData.checkItemId !== checkId) {
        continue;
      }
      list.push(defaultData);
    }
    return list;
  }
}
